import script from "./EspejoGaladrielView.vue?vue&type=script&setup=true&lang=js"
export * from "./EspejoGaladrielView.vue?vue&type=script&setup=true&lang=js"

import "./EspejoGaladrielView.vue?vue&type=style&index=0&id=0b730da1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b730da1"]])

export default __exports__